export default {
    'create-financial-file': 'Create financial file',
    'create-backup': 'Create backup',
    'edit-financial-file': 'Edit financial file',
    currency: 'Currency',
    save: 'Save',
    cancel: 'Cancel',

    confirm: 'Confirm',
    'browse-content': 'View content',

    'do-you-want-to-change-the-current-financial-file': 'Do you want to change the current financial file',

    'rotated-to-$': 'Revolved to "{financialFile}"',
    rotated: 'Revolved',
    locked: 'Closed',
    unlocked: 'Unclosed',

    'the-users-of-the-file-$-and-their-permissions': '{financialFile} file users and their permissions',

    permissions: {
        title: 'permissions',
        'no-permissions': 'No permissions',
        viewer: 'Read-only permission',
        accountant: 'Accountant',
        'warehouse-keeper': 'Warehouse keeper',
        'warehouse-manager': 'Warehouse manager'
    },

    'the-logo-is-uploaded-successfully': 'The logo is uploaded successfully'
}